import React from 'react';
import ConfidenceIndicator from './ConfidenceIndicator';
import PriorityFlag from './PriorityFlag';
interface SubmissionCardProps {
  id: string;
  submitter: string;
  stakeholderType: string;
  date: string;
  excerpt: string;
  themes: string[];
  priority: 'low' | 'medium' | 'high' | 'critical';
  confidence: number;
  treatyRelevant?: boolean;
}
const SubmissionCard: React.FC<SubmissionCardProps> = ({
  id,
  submitter,
  stakeholderType,
  date,
  excerpt,
  themes,
  priority,
  confidence,
  treatyRelevant = false
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-106">
      <div className="p-5" data-id="element-107">
        <div className="flex justify-between items-start" data-id="element-108">
          <div data-id="element-109">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-110">{submitter}</h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-111">
              {stakeholderType} • Submission {id} • {date}
            </p>
          </div>
          <div className="flex space-x-2" data-id="element-112">
            <PriorityFlag level={priority} data-id="element-113" />
            {treatyRelevant && <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-114">
                Treaty
              </span>}
          </div>
        </div>
        <p className="mt-3 text-sm text-gray-600 line-clamp-3" data-id="element-115">{excerpt}</p>
        <div className="mt-3" data-id="element-116">
          <div className="flex flex-wrap gap-1" data-id="element-117">
            {themes.map((theme, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-118">
                {theme}
              </span>)}
          </div>
        </div>
        <div className="mt-4 flex justify-between items-center" data-id="element-119">
          <ConfidenceIndicator score={confidence} data-id="element-120" />
          <button className="text-sm text-blue-600 hover:text-blue-500 font-medium" data-id="element-121">
            View full submission
          </button>
        </div>
      </div>
    </div>;
};
export default SubmissionCard;